import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { usePriceComponents } from "@/components/Sections/Price";
import { ComponentWrapper } from "@/components/Sections/Price/ComponentWrapper";
import { Divider } from "@gemini/ui";
import { PriceUnit } from "@/components/Sections/Price/PriceUnit";
import { Box } from "@gemini/core";
export const PriceComponents = () => {
    const components = usePriceComponents();
    if (!(components === null || components === void 0 ? void 0 : components.length))
        return null;
    return (_jsx(_Fragment, { children: components.map(({ key, type, units }, index) => (_jsx(ComponentWrapper, { type: type, marginTop: index > 0 ? "spacing.32" : "spacing.none", children: units.map((unit, unitIndex) => (_jsxs(Box, { children: [unitIndex > 0 && (_jsx(Divider, { marginVertical: "spacing.16", "aria-hidden": "true" })), _jsx(PriceUnit, { unit: unit })] }, unit.key))) }, key))) }));
};
